import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from '@/providers/AuthProvider';
import { Toaster } from '@/components/ui/sonner';
import App from './App';
import * as Sentry from '@sentry/react';
/* NEED THIS FILE TO BE PRESENT FOR TAILWIND INTELLISENSE TO WORK */
import '@/assets/styles/tailwind.css';
import '@/assets/styles/globals.css';
import { queryClient } from './queries';
import { QueryClientProvider } from '@tanstack/react-query';

const root = createRoot(document.getElementById('root') as HTMLElement, {
    onRecoverableError: Sentry.reactErrorHandler(),
});

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <AuthProvider>
                    <App />
                    <Toaster />
                </AuthProvider>
            </QueryClientProvider>
        </BrowserRouter>
    </React.StrictMode>
);
